// src/components/LegalDocumentPage.js
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { marked } from 'marked';
import { Helmet } from 'react-helmet-async';

// Configure marked to sanitize the HTML
marked.setOptions({
  sanitize: true
});

const LegalDocumentPage = () => {
  const { documentType } = useParams();
  const [content, setContent] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Determine document title and file path based on document type
  const getDocumentInfo = () => {
    switch (documentType) {
      case 'privacy-policy':
        return {
          title: 'Privacy Policy',
          filePath: '/legal/privacy-policy.md',
        };
      case 'terms-of-service':
        return {
          title: 'Terms of Service',
          filePath: '/legal/terms-of-service.md',
        };
      default:
        return {
          title: 'Legal Document',
          filePath: null,
        };
    }
  };

  const { title, filePath } = getDocumentInfo();

  useEffect(() => {
    if (!filePath) {
      setError('Document not found');
      setIsLoading(false);
      return;
    }

    // Fetch the markdown file
    fetch(filePath)
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to load document');
        }
        return response.text();
      })
      .then(text => {
        // Convert markdown to HTML
        const htmlContent = marked(text);
        setContent(htmlContent);
        setIsLoading(false);
      })
      .catch(err => {
        console.error('Error loading document:', err);
        setError('Failed to load document. Please try again later.');
        setIsLoading(false);
      });
  }, [filePath]);

  return (
    <>
      <Helmet>
        <title>{title} | ReelIntro</title>
      </Helmet>
      
      <div className="container mx-auto px-4 py-8 flex-grow">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-6">
          {isLoading ? (
            <div className="flex justify-center items-center h-64">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
            </div>
          ) : error ? (
            <div className="text-center py-10">
              <h2 className="text-2xl font-bold text-red-600 mb-4">{error}</h2>
              <Link to="/" className="text-blue-600 hover:underline">Return to Home</Link>
            </div>
          ) : (
            <div className="legal-document prose prose-lg max-w-none">
              <div dangerouslySetInnerHTML={{ __html: content }} />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default LegalDocumentPage;